// Component Imports
import BackgroundVideo from "./components/BackgroundVideo";
import DropdownButtons from "./components/DropdownButtons";
import SfPhotoCarousel from "./components/SfPhotoCarousel";
import Navbar from "./components/Navbar";
import { RecipeArchive } from "./components/RecipeArchive";
import { ProductArchive } from "./components/ProductArchive";
import { BlogArchive } from "./components/BlogArchive";
import { SandersonVideos } from "./components/SandersonVideos";
// import ContactForm from "./components/ContactForm";
import NewsletterForm from "./components/NewsletterForm";
import { StoreLocator } from "./components/StoreLocator";
import { Faq } from "./components/Faq";
import FlipThisRecipe from "./components/FlipThisRecipe";

// Analytics Imports
import Analytics, { EventTypes } from "./analytics"; // Ensure Analytics is imported correctly
import { Logger } from "./helpers";

/**
 * Initializes archive scripts based on the presence of specific elements.
 */
const initArchives = () => {
  if (document.getElementById("recipe-archive")) new RecipeArchive();
  if (document.getElementById("product-archive")) new ProductArchive();
  if (document.getElementById("news-archive")) new BlogArchive();
};

/**
 * Initializes video and carousel components.
 */
const initMediaComponents = () => {
  document.querySelectorAll(".sf-bg-video").forEach((el) => new BackgroundVideo(el));
  document.querySelectorAll(".sf-photo-carousel").forEach((el) => new SfPhotoCarousel(el));
  // If .sanderson-video-item exists, initialize SandersonVideos
  if (document.querySelector(".sanderson-video-item")) new SandersonVideos();
};

/**
 * Initializes UI components like the navbar and dropdown buttons.
 */
const initUIComponents = () => {
  const navbarEl = document.getElementById("sf-navbar");
  if (navbarEl) new Navbar(navbarEl);
  new DropdownButtons();
};

// Initialize the blocks when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  initArchives();
  initMediaComponents();
  initUIComponents();
});




// Print button replacement
const printButtons = document.querySelectorAll(".print-button");
printButtons.forEach((el) => {
  el.addEventListener("click", function (evt) {
    evt.preventDefault();
    window.print();
  });
});

// Copy to Clipboard button
const copyButtons = document.querySelectorAll(".copy-to-clipboard");
copyButtons.forEach((el) => {
  el.addEventListener("click", function (evt) {
    if ("clipboard" in navigator) {
      evt.preventDefault();
      // Store to clipboard
      navigator.clipboard.writeText(el.getAttribute("href"));
      // Update display
      var shareButton = el.querySelector(".share-text");
      if (shareButton) shareButton.innerHTML = "Copied";
      setTimeout(function () {
        shareButton.innerHTML = "Share";
      }, 500);
    }
  });
});


// Normal Scripts, the self-invoking function may not be needed
(function () {
  // Initialize the Analytics module and track the initial page view.
  Analytics.getInstance();
  analytics.track(EventTypes.PageView, { url: window.location.href });

  // YouTube Conversions, if the pathname starts with "/store-finder", track with a different label
  if ( window.location.pathname.startsWith("/store-finder") || window.location.pathname === "/store-finder/" ) {
    analytics.track.client("conversion", { youtube_label: "YHQ7CJX-sdAaEN-e4eg_" }, ["youtube"]);
  } else {
    // Track the custom "conversion" event for the page view with YouTube
    analytics.track.client("conversion", { youtube_label: "7RVxCKCyhNIaEN-e4eg_"}, ["youtube"]);
  }

  


  // Track base intel events
  window.addEventListener("baseIntelLoaded", () => {
    if (!window.baseIntel) return;
    // Track Chat Open
    baseIntel.on("open", () => {
      analytics.track.client("ai_chat--open", { event_category: "ai_chat" }, ["googleAnalytics"]);
    });
    // Track question asked
    baseIntel.on("questionAsked", () => {
      analytics.track.client("ai_chat--question_asked", { event_category: "ai_chat" }, ["googleAnalytics"]);
    });
  });

  // If we have the store locator page, load its class and track the event
  const storeLocatorEle = document.querySelector("div.pb_store_locator");
  if ( storeLocatorEle ) {
    new StoreLocator(storeLocatorEle);
    analytics.track(EventTypes.FindLocation, { url: window.location.href });
  }

  // Initialize the NewsletterForm component for each newsletter form
  const newsletterForms = document.querySelectorAll("form.newsletter-form");
  if ( newsletterForms ) {
    // For each form, we need to create a new instance of the NewsletterForm class
    newsletterForms.forEach((form) => {
      new NewsletterForm(form);
    });
  }

  // If we have a contact form, load the class
  const contactForm = document.querySelector(".pb_contact_form ");
  if ( contactForm ) {
    // Page is currently removed
    // new ContactForm(contactForm);
  }

  // If we have a faqs class, load the JS class
  const questions = document.querySelector("div.faqs");
  if (questions) {
    const tabs = document.querySelector("section.faq-block ul.tabs");
    const faq = new Faq(questions, tabs);
  }
})();


// FlipThisRecipe class
//trying to make scroll smoother? !TODO: Use AI?

const isRecipePage = window.location.pathname.includes("/recipes/");
const flipButton = document.querySelector(".flip-this-recipe");
const heroContainer = document.querySelector(".hero-container");
const nextHeroContainer = document.querySelector(".next-hero-container");

if (
  flipButton &&
  isRecipePage &&
  heroContainer &&
  nextHeroContainer
) {
  // Get Link
  const flipThisRecipeLink = flipButton.getAttribute("href");
  new FlipThisRecipe(
    flipButton,
    heroContainer,
    nextHeroContainer,
    flipThisRecipeLink
  );
  // console.log("Instantiated FlipThisRecipe");
} else {
  // console.log("FlipThisRecipe not instantiated");
}


document.addEventListener("DOMContentLoaded", () => {
  const scrollPosition = sessionStorage.getItem("scrollPosition");
  if (scrollPosition) {
    const targetPosition = parseInt(scrollPosition);
    const duration = 500; // Duration of the scrolling animation in milliseconds
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const startTime = performance.now();

    function scrollAnimation(currentTime) {
      const elapsedTime = currentTime - startTime;
      const scrollProgress = Math.min(elapsedTime / duration, 1);
      const easedProgress = easeInOutCubic(scrollProgress);
      window.scrollTo(0, startPosition + distance * easedProgress);

      if (elapsedTime < duration) {
        window.requestAnimationFrame(scrollAnimation);
      }
    }

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }

    window.requestAnimationFrame(scrollAnimation);
    sessionStorage.removeItem("scrollPosition");
  }
});

// Injects legal banner offset and handles dismiss logic with responsive navbar adjustment
/**
 * @fileoverview Injects and manages the Legal Update banner with accept/dismiss logic.
 * Ensures accessibility and sets a dismissal cookie to avoid future display.
 */
(() => {
  // Locate the main banner element
  const banner = document.getElementById("legal-update-banner");

  // Exit early if the banner is not present on the page
  if (!banner) return;

  // Locate the inner container where we'll append the dismiss button
  const bannerContainer = banner.querySelector(".notice-container");

  // Exit if structure is unexpected
  if (!bannerContainer) {
    console.warn("Banner container not found inside #legal-update-banner.");
    return;
  }

  // Create the dismiss/accept button dynamically
  const closeButton = document.createElement("a");
  closeButton.id = "dismiss-legal-banner";
  closeButton.setAttribute("aria-label", "Dismiss notice"); // Accessibility
  closeButton.innerHTML = "Accept"; // Button label text

  // Append the button inside the notice container
  bannerContainer.appendChild(closeButton);

  // Bind click event to dismiss banner and store a 30-day cookie
  closeButton.addEventListener("click", () => {
    banner.remove(); // Remove the banner from view

    // Set dismissal cookie with 30-day expiration
    const now = new Date();
    const expirationDate = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `legal-banner-dismissed=true; expires=${expirationDate.toUTCString()}; path=/`;

    // Fire a resized event from the navbar element, mostly to let the body to know to move up.
    document.querySelector("header.sf-navbar").dispatchEvent(new Event("resized"));
  });
})();